import BaseService from '../services/BaseService';

const FACET_BY_FIELD = {
  numPatrimonio: 'NUM_PATRIMONIO',
  numSerie: 'NUM_SERIE',
  codigoSisant: 'CODIGO_SISANT',
};

const mapOption = (item) => {
  if (item == null) return null;
  if (typeof item === 'string') {
    const value = item.trim();
    return value ? { value, label: value } : null;
  }
  const value = String(item.id ?? item.value ?? '').trim();
  if (!value) return null;
  const label = String(item.label ?? item.nome ?? value).trim() || value;
  return { value, label };
};

export const readTipoEquipamentos = (filter) => {
  if (Array.isArray(filter?.tipoEquipamentos) && filter.tipoEquipamentos.length) {
    return filter.tipoEquipamentos;
  }
  if (filter?.tipoEquipamento) return [filter.tipoEquipamento];
  return [];
};

/**
 * Lista distinta para o filtro sync.
 * `GET equipamentos/filter-options/{facet}?tipoEquipamentos=`
 * @param {string} field `numPatrimonio` | `numSerie` | `codigoSisant` ou o enum da facet
 * @param {string[]} [tipoEquipamentos]
 */
export async function fetchEquipamentoDistinctOptions(field, tipoEquipamentos) {
  const facet = FACET_BY_FIELD[field] || field;
  const params = new URLSearchParams();
  const tipos = Array.isArray(tipoEquipamentos) ? tipoEquipamentos.filter(Boolean) : [];
  if (tipos.length) {
    params.append('tipoEquipamentos', tipos.join(','));
  }
  const query = params.toString();
  const response = await BaseService.get({
    url: `equipamentos/filter-options/${facet}${query ? `?${query}` : ''}`,
  });
  const list = Array.isArray(response?.data) ? response.data : [];
  return list.map(mapOption).filter(Boolean);
}
